function ArrowRightIcon({ size = 16, color = 'gray'}) {
    return (
        <svg viewBox="0 0 16 16" width={size} height={size} fill={color}>
            <path d="M13 8C12.9938 7.80932 12.9162 7.62035 12.7668 7.47461L6.36138 1.22802C6.05055 0.923993 5.54555 0.923993 5.2338 1.22802C4.92207 1.53114 4.92207 2.02364 5.2338 2.32764L11.0504 8L5.2338 13.6724C4.92207 13.9764 4.92207 14.4689 5.2338 14.772C5.54555 15.076 6.05053 15.076 6.36138 14.772L12.7668 8.52539C12.9162 8.37968 12.9938 8.19068 13 8Z" />
        </svg>
    );
}

export default ArrowRightIcon;
